import { useApi } from './useApi';

export function useBankAccounts() {
  const { fetchData, postData, putData, deleteData } = useApi();

  const extractError = (err, fallback) =>
    err?.response?.data?.message || err?.message || fallback;

  const fetchBankAccountsApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/bank_accounts', { params });
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: extractError(err, 'Lỗi kết nối') };
    }
  };

  const fetchActiveBankAccountsApi = async () => {
    try {
      const result = await fetchData('/api/bank_accounts/active');
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: extractError(err, 'Lỗi kết nối') };
    }
  };

  const createBankAccountApi = async (credentials) => {
    try {
      const result = await postData('/api/bank_accounts', credentials);
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: extractError(err, 'Lỗi tạo mới') };
    }
  };

  const updateBankAccountApi = async (id, credentials) => {
    try {
      const result = await putData(`/api/bank_accounts/${id}`, credentials);
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: extractError(err, 'Lỗi cập nhật') };
    }
  };

  const deleteBankAccountApi = async (id) => {
    try {
      const result = await deleteData(`/api/bank_accounts/${id}`);
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: extractError(err, 'Lỗi xóa dữ liệu') };
    }
  };

  const setDefaultBankAccountApi = async (id) => {
    try {
      const result = await postData(`/api/bank_accounts/${id}/set-default`);
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: extractError(err, 'Lỗi thiết lập mặc định') };
    }
  };

  const fetchBankAccountStatsApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/bank_accounts/stats', { params });
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: extractError(err, 'Lỗi lấy thống kê') };
    }
  };

  const setCompanyFlagApi = async (id, isCompany) => {
    try {
      const result = await putData(`/api/bank_accounts/${id}/is-company`, { is_company: isCompany });
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: extractError(err, 'Lỗi cập nhật') };
    }
  };

  const assignCustomersApi = async (id, customerIds) => {
    try {
      const result = await postData(`/api/bank_accounts/${id}/assign-customers`, { customer_ids: customerIds });
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: extractError(err, 'Lỗi gán khách hàng') };
    }
  };

  const getAssignedCustomersApi = async (id) => {
    try {
      const result = await fetchData(`/api/bank_accounts/${id}/assigned-customers`);
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: extractError(err, 'Lỗi lấy danh sách khách hàng') };
    }
  };

  return {
    fetchBankAccountsApi,
    fetchActiveBankAccountsApi,
    createBankAccountApi,
    updateBankAccountApi,
    deleteBankAccountApi,
    setDefaultBankAccountApi,
    fetchBankAccountStatsApi,
    setCompanyFlagApi,
    assignCustomersApi,
    getAssignedCustomersApi,
  };
}
